import { render, staticRenderFns } from "./addDuty.vue?vue&type=template&id=18175439&scoped=true&"
import script from "./addDuty.vue?vue&type=script&lang=js&"
export * from "./addDuty.vue?vue&type=script&lang=js&"
import style0 from "./addDuty.vue?vue&type=style&index=0&id=18175439&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18175439",
  null
  
)

export default component.exports